import React from "react";
import Error400 from "./Components/Pages/ErrorPages/ErrorPage400";
import Error401 from "./Components/Pages/ErrorPages/ErrorPage401";
import Error403 from "./Components/Pages/ErrorPages/ErrorPage403";
import Error404 from "./Components/Pages/ErrorPages/ErrorPage404";
import Error500 from "./Components/Pages/ErrorPages/ErrorPage500";
import Error503 from "./Components/Pages/ErrorPages/ErrorPage503";

function Fallback({ error, resetErrorBoundary }) {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        return <Error400 resetErrorBoundary={resetErrorBoundary}  />;
      case 401:
        return <Error401 resetErrorBoundary={resetErrorBoundary}  />;
      case 403:
        return <Error403 resetErrorBoundary={resetErrorBoundary}  />;
      case 404:
        return <Error404 resetErrorBoundary={resetErrorBoundary}  />;
      case 500:
        return <Error500  resetErrorBoundary={resetErrorBoundary} />;
      case 503:
        return <Error503 resetErrorBoundary={resetErrorBoundary}  />;
      default:
        return <Error500 resetErrorBoundary={resetErrorBoundary} />;
    }
  } else if (error === "Network Error") {
    return <Error500 resetErrorBoundary={resetErrorBoundary} />;
  } else {
    return <Error500 resetErrorBoundary={resetErrorBoundary} />;
  }
}

export default Fallback;